import { DefaultTheme } from 'styled-components';
import { PhaseType } from 'types/package';

export const STICKY_NAV_HEIGHT = '68px';

export const getColorLightBG = (theme: DefaultTheme, variant: PhaseType) => {
  switch (variant) {
    case '1':
      return theme.colors.phaseColors.phaseOneDarkest;
    case '2':
      return theme.colors.phaseColors.phaseTwoDarkest;
    case '3':
      return theme.colors.phaseColors.phaseThreeDarkest;
  }
};

export const getColorDarkBG = (theme: DefaultTheme, variant: PhaseType) => {
  switch (variant) {
    case '1':
      return theme.colors.phaseColors.phaseOneDefault;
    case '2':
      return theme.colors.phaseColors.phaseTwoDefault;
    case '3':
      return theme.colors.phaseColors.phaseThreeDefault;
  }
};

export const getListLabel = (index: number) => {
  if (index < 9) {
    return `0${index + 1}. `;
  } else return `${index + 1}. `;
};

export const getListItemColor = (
  theme: DefaultTheme,
  isDropdownListItem?: boolean,
  isActiveSection?: boolean,
  isLightBG?: boolean,
) => {
  if (isLightBG) {
    return isActiveSection
      ? theme.colors.textColors.primaryDark
      : theme.colors.textColors.tertiaryDark;
  } else {
    if (isDropdownListItem) {
      return isActiveSection
        ? theme.colors.textColors.primaryLight
        : theme.colors.textColors.secondaryLight;
    }
    return theme.colors.textColors.primaryLight;
  }
};
